import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  class: "jl2-custom-filled-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-miterlimit": "10"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20.3041 13.6525C20.3041 16.667 17.8657 19.1054 14.8513 19.1054C11.8369 19.1054 9.39844 16.667 9.39844 13.6525C9.39844 12.2701 9.91684 11.0125 10.7616 10.0525C11.7601 8.91971 13.2289 8.19971 14.8513 8.19971C17.8657 8.19971 20.3041 10.6381 20.3041 13.6525Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "stroke-content"
    }, null, -1),
    _createElementVNode("path", {
      d: "M23.7777 22.5998L19.832 18.6445",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "stroke-content"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.125 13.6533H17.4722",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      class: "stroke-content"
    }, null, -1)
  ])))
}